export default __webpack_public_path__ + "3e66c441bcd801581288a57db36d40b4.png";